import { useQuery, useMutation } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/sales-commission'
const QUERY_KEY = 'sales-commission'

export const useGetSalesCommissions = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, query],
    async () => (await API.get(serializeQuery(ENDPOINT, query))).data,
    config
  )

export const usePostSalesCommission = (config = {}) =>
  useMutation((newData) => API.post(ENDPOINT, newData), config)

export const useDeleteSalesCommission = (config = {}) =>
  useMutation((id) => API.delete(ENDPOINT, { data: id }), config)

export const useExportSalesCommission = (config = {}) =>
  useMutation((body) => API.post(`${ENDPOINT}/export`, body, { responseType: 'blob' }), config)

export const useGetSalesCommissionsPayout = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'payout', query],
    async () => (await API.get(serializeQuery(`${ENDPOINT}/payout`, query))).data,
    config
  )

export const usePostSalesCommissionPayout = (config = {}) =>
  useMutation((newData) => API.post(`${ENDPOINT}/payout`, newData), config)

export const useDeleteSalesCommissionPayout = (config = {}) =>
  useMutation((id) => API.delete(`${ENDPOINT}/payout`, { data: id }), config)

export const useSendPayoutEmailById = (config = {}) =>
  useMutation((newData) => API.post(`${ENDPOINT}/send-email`, newData), config)

export const useSendBulkPayoutEmails = (config = {}) =>
  useMutation((newData) => API.post(`${ENDPOINT}/send-bulk-emails`, newData), config)
